module.exports = "/_next/static/images/game-1-phone-gallery-08-23-1120-69d5654e92b51d5d4cc0baa1e9d54640.jpg";